import { useState, useEffect } from 'react'

export function useCountdown(durationInSeconds: number = 600) {
  const [timeLeft, setTimeLeft] = useState(durationInSeconds)
  const [isExpired, setIsExpired] = useState(false)

  useEffect(() => {
    // Check if we already have an expiry time in localStorage
    const storedExpiry = localStorage.getItem('offer_countdown_expiry')
    let expiryTime: number

    if (storedExpiry) {
      expiryTime = parseInt(storedExpiry, 10)
    } else {
      // Set new expiry time
      expiryTime = Date.now() + durationInSeconds * 1000
      localStorage.setItem('offer_countdown_expiry', expiryTime.toString())
    }

    const calculateTimeLeft = () => {
      const now = Date.now()
      const difference = Math.max(0, Math.floor((expiryTime - now) / 1000))

      if (difference <= 0) {
        setIsExpired(true)
        return 0
      }

      return difference
    }

    setTimeLeft(calculateTimeLeft())

    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft()
      setTimeLeft(newTimeLeft)

      if (newTimeLeft <= 0) {
        clearInterval(timer)
      }
    }, 1000)

    return () => clearInterval(timer)
  }, [durationInSeconds])

  const hours = Math.floor(timeLeft / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60

  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isExpired,
  }
}
